import { sanitizeUrl } from "@braintree/sanitize-url";
import { LoadingIndicator } from "@k8slens/lds";
import { useLocalStorage } from "usehooks-ts";
import { useEffect } from "react";
import { getRedirectToIdpLogInUrl } from "src/services/getRedirectToIdpLogInUrl";
import { useLocation } from "react-router-dom";
import { legacyKeycloakIframeRedirectLocalStorageKey, lensDesktopAuthUrlLocalStorageKey } from "src/constants";
import { isAuthorizedRedirectUri } from "src/services/getRedirectAuthToLensDesktopUrl";

export const RedirectToIdpLogIn = () => {
  const location = useLocation();
  const [value, setValue] = useLocalStorage(legacyKeycloakIframeRedirectLocalStorageKey, "");
  const [, setLensDesktopAuthUrl] = useLocalStorage(lensDesktopAuthUrlLocalStorageKey, "");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const redirectUri = searchParams.get("redirect_uri");

    if (redirectUri && isAuthorizedRedirectUri(redirectUri)) {
      setLensDesktopAuthUrl(window.location.href);
      setValue(redirectUri);
    }
  }, [location.search, setValue, setLensDesktopAuthUrl]);

  useEffect(() => {
    // ensure the url is saved before redirecting
    if (value) {
      window.location.replace(sanitizeUrl(getRedirectToIdpLogInUrl()));
    }
  }, [value]);

  return <LoadingIndicator size="2xl" />;
};
